import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { RootState } from '../../core/stores/store';
import { UserActions } from '../../core/stores/user/user.actions';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatIconModule
  ],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent {
  newPassword: string = '';
  username: string = '';
  userId: number = 0;
  token: string = '';

  passwordForm: FormGroup;
  hidePassword: boolean = true;

  constructor(
    private store: Store<RootState>,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private translateService: TranslateService
  ) {
    this.translateService.setDefaultLang('en');
    this.translateService.use(this.translateService.getBrowserLang() || 'en');
    
    this.route.queryParams.subscribe((params) => {
      this.username = params['username'] || '';
      this.token = params['token'] || '';
      this.userId = params['userId'] ? Number(params['userId']) : 0;

      if (!this.username || !this.userId || !this.token) {
        alert('Faltan datos para restablecer la contraseña.');
        this.router.navigate(['/login']);
      }

      this.store.dispatch(UserActions.setToken({ token: this.token }));
    });

    this.passwordForm = this.formBuilder.group({
      newPassword: [null, { validators: [Validators.required], updateOn: 'change' }]
    })
  }

  onSubmit() {
      const password = this.passwordForm.get('newPassword')?.value;
      if (!password || password.length < 6) {
        alert('La contraseña debe ser de al menos 6 caracteres');
        return;
      }
      this.store.dispatch(UserActions.updateUser({ payload: { user_id: this.userId, password } }));
      this.router.navigate(['/login']);
  }
}
